import React from 'react';
import { Typography, Grid } from '@mui/material';
import { MenuWithId } from 'components';
import { useTranslation } from 'react-i18next';
import { useEvents } from 'hooks';
const LayerFilter = () => {
  const { t } = useTranslation();
  const { setFilter, filters } = useEvents();
  const menuItems = [
    { id: 0, name: 'Any' },
    { id: 1, name: 'Property' },
    { id: 2, name: 'Field' },
    { id: 3, name: 'Device' },
  ];

  return (
    <Grid item xs={12} md={6} lg={6}>
      <Typography>{t('layer')}</Typography>
      <MenuWithId
        placeholder={t('any')}
        label={t('any')}
        menuItems={menuItems}
        selectedItem={filters?.layer}
        selectItem={(item) => setFilter({ layer: item.name === 'Any' ? '' : item.name })}
        size="normal"
      />
    </Grid>
  );
};

LayerFilter.propTypes = {};

export default LayerFilter;
